module.exports = __webpack_public_path__ + "financial-profit.ec3081b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/AdminRegistration/financial-profit.png
// module id = 3125
// module chunks = 0